/* 👻🚨👻🚨👻 Let op! This code has been auto generated, so best not to touch it 👻🚨👻🚨👻 */
import * as Types from '@repo/graphql-types';

import type { FetchOptions } from 'codegen/fetcher/fetcher.types'
import { fetcher } from 'codegen/fetcher'
import { useQuery, type UseQueryOptions } from '@tanstack/react-query'
export type UserCoinBalanceQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type UserCoinBalanceQuery = { __typename?: 'Query', userBalance: { __typename?: 'UserBalance', balance: number } };

export type CoinEarnAmountsQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type CoinEarnAmountsQuery = { __typename?: 'Query', coinEarnAmounts: { __typename?: 'CoinsEarnAmountResponse', amounts?: Array<{ __typename?: 'CoinEarnAmount', earnType: Types.CoinEarnType, amount: number }> | null } };


export const UserCoinBalanceDocument = `
query userCoinBalance {
  userBalance {
    balance
  }
}

`

export const userCoinBalanceQueryRootKey = 'userCoinBalance'

export function userCoinBalanceQueryFetcher(variables?: UserCoinBalanceQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<UserCoinBalanceQuery, UserCoinBalanceQueryVariables>(UserCoinBalanceDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function userCoinBalanceQueryKey(variables?: UserCoinBalanceQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [userCoinBalanceQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function userCoinBalanceQueryOptions(
    variables?: UserCoinBalanceQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<UserCoinBalanceQuery, unknown, UserCoinBalanceQuery, (UserCoinBalanceQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: userCoinBalanceQueryKey(variables, fetchOptions),
        queryFn: userCoinBalanceQueryFetcher(variables, fetchOptions),
    }
}

export function useUserCoinBalanceQuery<D = UserCoinBalanceQuery, E = unknown>(
    variables?: UserCoinBalanceQueryVariables,
    options?: Omit<UseQueryOptions<UserCoinBalanceQuery, E, D, (UserCoinBalanceQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<UserCoinBalanceQuery, E, D, (UserCoinBalanceQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...userCoinBalanceQueryOptions(variables, fetchOptions),
    })
}

export const CoinEarnAmountsDocument = `
query coinEarnAmounts {
  coinEarnAmounts {
    amounts {
      earnType
      amount
    }
  }
}

`

export const coinEarnAmountsQueryRootKey = 'coinEarnAmounts'

export function coinEarnAmountsQueryFetcher(variables?: CoinEarnAmountsQueryVariables, fetchOptions?: FetchOptions) {
    return fetcher<CoinEarnAmountsQuery, CoinEarnAmountsQueryVariables>(CoinEarnAmountsDocument, variables, fetchOptions?.headers, fetchOptions)
}

// hello curious person. if you are here and wondering why the typing is so complicated,
// it's bcos fetchOptions need to be considered as part of the query key.
// they are able to affect the response of the query, so they need to be part of the cache key.
export function coinEarnAmountsQueryKey(variables?: CoinEarnAmountsQueryVariables, fetchOptions?: FetchOptions) {
    const key: (string | FetchOptions)[]  = [coinEarnAmountsQueryRootKey]
    if (fetchOptions) {key.push(fetchOptions)}
    return variables === undefined ? key : [...key, variables]
}

export function coinEarnAmountsQueryOptions(
    variables?: CoinEarnAmountsQueryVariables,
    fetchOptions?: FetchOptions
): Pick<UseQueryOptions<CoinEarnAmountsQuery, unknown, CoinEarnAmountsQuery, (CoinEarnAmountsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'> {
    return {
        queryKey: coinEarnAmountsQueryKey(variables, fetchOptions),
        queryFn: coinEarnAmountsQueryFetcher(variables, fetchOptions),
    }
}

export function useCoinEarnAmountsQuery<D = CoinEarnAmountsQuery, E = unknown>(
    variables?: CoinEarnAmountsQueryVariables,
    options?: Omit<UseQueryOptions<CoinEarnAmountsQuery, E, D, (CoinEarnAmountsQueryVariables | FetchOptions | string)[]>, 'queryKey' | 'queryFn'>,
    fetchOptions?: FetchOptions
) {
    return useQuery<CoinEarnAmountsQuery, E, D, (CoinEarnAmountsQueryVariables | FetchOptions | string)[]>({
        ...options,
        ...coinEarnAmountsQueryOptions(variables, fetchOptions),
    })
}